<template>
    <div class="overlay" ref="overlay">
        <PageHeader theme="dark" />
        <div class="overlay_inner_wrapper">
            <Case v-if="type == 'case'" :content=content />
            <AboutPage v-if="type == 'about'" />
            <PollPage v-if="type == 'poll'" />
        </div>
    </div>
</template>

<script>
    import PageHeader from '../components/PageHeader'
    import Case from '../views/Case'
    import PollPage from '../views/Poll'
    import AboutPage from '../views/About'

    export default {
        name: "Overlay",
        components: { PageHeader, AboutPage, Case, PollPage },
        props: { },
        data: () => ({
            type:'', content:{}
        }),
        created(){
            let self = this
            this.$root.$on('showOverlay', data => {
                self.type = data.type
                self.content = data.content
                self.show()
            })
            this.$root.$on('hideOverlay', data => self.hide())
        },
        mounted(){
        },
        methods: {
            show(){
                document.body.style.overflowY = 'hidden'
                this.$refs.overlay.classList.add('open')
            },
            hide(){
                let self = this
                document.body.style.overflowY = 'visible'
                self.$refs.overlay.classList.remove('open')
            }
        }
    }
</script>

<style lang="scss">
    .overlay {
        position:fixed; z-index:2; width:0px; height:0px; top:0; left:0; background:#fff; opacity:0; transition:opacity .2s ease;
        &.open { width:100vw; height:100vh; opacity:1; transition:opacity .2s ease; overflow-y:scroll }

        .overlay_inner_wrapper { padding:80px 0; }
    }
</style>